import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid2';

import { useFooterContent } from '@/hooks/useFooterContent';

import { FooterBrand } from './FooterBrand';
import { FooterContactStrip } from './FooterContactStrip';
import { FooterLegalBar } from './FooterLegalBar';
import { FooterLinks } from './FooterLinks';

const glow = (at: string, alpha: number) =>
  `radial-gradient(60rem 28rem at ${at}, rgba(var(--mui-palette-primary-mainChannel) / ${alpha}), transparent 70%)`;

/** Site footer: brand pitch, link groups, contact cards and the legal bar. */
export function SiteFooter() {
  const { brand, columns, contact, legal } = useFooterContent();
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'surfaceVariant',
        // Soft brand-red glows in opposite corners over the light surface.
        backgroundImage: `${glow('0% 0%', 0.12)}, ${glow('100% 100%', 0.08)}`,
        borderTop: 1,
        borderColor: 'divider',
        pt: { xs: 14, md: 20 },
        pb: 8,
      }}
    >
      <Container maxWidth="xl">
        <Grid container spacing={{ xs: 12, lg: 10 }}>
          <Grid size={{ xs: 12, lg: 4 }}>
            <FooterBrand brand={brand} />
          </Grid>
          <Grid size={{ xs: 12, lg: 8 }}>
            <FooterLinks columns={columns} />
          </Grid>
        </Grid>
        <Box sx={{ mt: { xs: 12, md: 16 } }}>
          <FooterContactStrip contact={contact} />
        </Box>
        <Box sx={{ mt: { xs: 10, md: 12 } }}>
          <FooterLegalBar legal={legal} />
        </Box>
      </Container>
    </Box>
  );
}
